export const DRILLS_MODULES_REQUEST = "DRILLS_MODULES_REQUEST";
export const DRILLS_MODULES_SUCCESS = "DRILLS_MODULES_SUCCESS";
export const  DRILLS_MODULES_FAILURE = "DRILLS_MODULES_FAILURE";